export default "__VITE_ASSET__DgnpBom5__"